'use strict';

var define = require('define-properties');

var util = require('util');

var implementation = require('./implementation');

var getPolyfill = require('./polyfill');

var polyfill = getPolyfill();

var shim = require('./shim');
/* eslint-disable no-unused-vars */


var boundPromisify = function promisify(orig) {
  /* eslint-enable no-unused-vars */
  return polyfill.apply(util, arguments);
};

define(boundPromisify, {
  custom: polyfill.custom,
  customPromisifyArgs: polyfill.customPromisifyArgs,
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = boundPromisify;